import { Page } from '../../layout/Page.tsx'

const Billing = () => {
	return <Page title="Billing" breadcrumbs="Billing" />
}

export default Billing
